import React, { useEffect,useState } from "react";
import { ethers, Signer } from "ethers";
import { EscrowContractAddress } from "../Services/EscrowContractAddress";
import EscrowContractAbi from "../Services/EscrowContractAbi.json";
import newContractAbi from "../Services/NewContractAbi.json";
import { Dialog } from "@headlessui/react";
import { NavLink ,useNavigate} from "react-router-dom";
import { Spinner } from "flowbite-react";

const Rejection = () => {

//------------------------------USESTATES---------------------------------------//
const [loading, setLoading] = useState(false);


  //-----------------------Connecting with Contract-----------------------------//

  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();

  const Contract = new ethers.Contract(
    EscrowContractAddress,
    EscrowContractAbi,
    signer
  );

  const navigate = useNavigate();

  //localStorage.setItem('receiverAddress', reciveraddress);
  const contractAddress = localStorage.getItem("Contracttocancel");
  console.log("Contract Address",contractAddress)

  //----------------FUNCTION TO CANCEL CONTRACT----------------------//
  const cancelContract = async () => {
   try{
    setLoading(true);
    const newContract = new ethers.Contract(
      contractAddress,
      newContractAbi,
      signer
    );
    console.log("NEw contract instance",newContract);
    newContract?.cancelDioSend().then(async (cancelresponse) => {
      cancelresponse.wait().then(async () => {
        console.log("RESPONSE FROM CANCEL REQUEST",cancelresponse)
        console.log("must get hash",cancelresponse);
        localStorage.setItem("cancelledhash",cancelresponse.hash);
        setLoading(false);
        navigate('/rejected');
      });
    });
   }catch(error){
   console.log("ERROR FROM CANCEL REQUEST ",error)
   //setLoading(false);
   }
  };

  //-------------------SOMETHING IN THE WAY-----------------------------//

  const cancelContract2 = async ()=>{
    const newContract = new ethers.Contract(
      contractAddress,
      newContractAbi,
      signer
    );

    console.log("new contract instance",newContract);
    newContract?.smartContract().then(async(response)=>{
      console.log(response);
    })
  }
  useEffect(() => {}, []);

  return (
    <div className="h-screen flex items-center justify-center ">
      {loading?(<Spinner/>):(<section class="rounded-3xl shadow-2xl">
        <div class="p-8 text-center sm:p-12">
          {/* <p class="text-sm font-semibold uppercase tracking-widest text-slate-500">
                        Enter rejection Code
                    </p> */}

          <h2 class="mt-6 text-2xl font-bold" >
            Are you sure you want to cancel?
          </h2>

          
            <a
              class="mt-8 inline-block w-full rounded-full bg-slate-600 hover:bg-slate-500 py-4 text-xl font-bold text-white shadow-xl"
              href="#/"
              onClick={cancelContract}
            >
              Yes
            </a>
         
          <NavLink to={"/recipientaccount"}>
            <a
              class="mt-8 inline-block w-full rounded-full bg-slate-600 hover:bg-slate-500 py-4 text-xl font-bold text-white shadow-xl"
              href="#/"
            >
              No
            </a>
          </NavLink>
        </div>
      </section>)}
    </div>
  );
};

export default Rejection;
